var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/socket.io-parser/~/isarray/index.js
// module id = 229
// module chunks = 1